import { render, staticRenderFns } from "./GeneralEditModal.vue?vue&type=template&id=3a874eaa&scoped=true&"
import script from "./GeneralEditModal.vue?vue&type=script&lang=js&"
export * from "./GeneralEditModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a874eaa",
  null
  
)

export default component.exports